import React from "react";
import { motion } from "framer-motion";
import { staggerVariants, VIEWPORT_ONCE } from "../lib/motion";

const stats = [
    { value: "10ms", label: "Avg execution speed" },
    { value: "100+", label: "Forex & crypto pairs" },
    { value: "1:500", label: "Maximum leverage" },
    { value: "24/5", label: "Trader support" },
];

const statVariants = staggerVariants({ y: 20, duration: 0.5, step: 0.08 });

export default function StatsBand() {
    return (
        <section
            data-testid="stats-band"
            className="relative py-16 lg:py-20 border-y border-white/5 bg-[#0A0E23]/50"
        >
            <div className="xpo-container">
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
                    {stats.map((s, i) => (
                        <motion.div
                            key={s.label}
                            variants={statVariants}
                            initial="hidden"
                            whileInView="visible"
                            custom={i}
                            viewport={VIEWPORT_ONCE}
                            className="text-center lg:text-left"
                        >
                            <p className="font-mono text-4xl lg:text-5xl font-extrabold text-white tracking-tight">
                                {s.value}
                            </p>
                            <p className="text-slate-400 text-sm mt-2">
                                {s.label}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
